import { defineStore } from "pinia";

export const useUiStore = defineStore({
    id: "ui",
    state: () => ({
        sidebarExpanded: true,
    }),
    actions: {
        toggleSidebar() {
            this.sidebarExpanded = !this.sidebarExpanded;
        },
    },
});
